//

export interface ILicz {
    opis: string;
    x: string|undefined;
    get_x():any
}

export class Wartość implements ILicz {
    opis: string;
    x: string|undefined;

    get_x():any {
        return this.x
    }

    constructor(opis:string, x:any) {
        this.opis=opis;
        this.x=x
    }

}

export class Licz implements ILicz {

    nazwa: string=""
    opis: string="";
    x: string|undefined=undefined;
    uwzględnia:  ILicz[]=[]
   

    constructor(nazwa_opis:string) {
        const arr = nazwa_opis.split('=')
        if (arr.length!=2) throw("Licz constructor: nazwa = opis expected")
        this.nazwa=arr[0].trim();
        this.opis=arr[1].trim();
        this.x=undefined;
    }

    set_x(x:any) {
        this.x=x;
    }

    get_x():any {
        return this.x
    }


    add_det(d:ILicz) {
        this.uwzględnia.push(d)
    }

    public static get_det(licz: Licz, title:string):ILicz {
        for (let i=0;i<licz.uwzględnia.length;i++) {
            const l:ILicz = licz.uwzględnia[i]
            if (l.opis==title) {
                return l;
            }
        }
        return new Licz(title);
    }
}

